import { FormFieldTypes } from "../../../../../data/formFieldType";

export const cpdprogrammesbyOverseasgreenbuildingCouncilsData = {
    name: 'CpdprogrammesbyOverseasgreenbuildingCouncils',
    initialState: {
        typeofCpdProgramme: '',
        nameofEventOrganiser: '',
        dateofProgramme: "",
        certificateofAttendance: "",
        CpdPoints: "",
        remarks: "",
        processedBy: "",
        cpdPointsAwarded: "",
        notes: "",
    },
    formFields: [
        {
            id: "cpdProgrammesInformation",
            lable: "",
            Field_Name: "cpdProgrammesInformation",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "cpdProgrammesInformation",
            fieldSetting: {
                formTitle: "CPD Programmes Information",
            },
            style: {
                containerCss: "col-lg-12 mb-4 text-left",
            },
        },
        {
            id: "typeofCpdProgramme",
            lable: "Type of CPD Programme",
            Field_Name: "Type of CPD Programme",
            fieldType: FormFieldTypes.INPUT,
            dataField: "typeofCpdProgramme",
            fieldSetting: {
                placeholder: "",
                options: []
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space"
            }
        },
        {
            id: "nameofEventOrganiser",
            lable: "Name of Event Organiser",
            Field_Name: "Name of Event Organiser",
            fieldType: FormFieldTypes.INPUT,
            dataField: "nameofEventOrganiser",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space",
            },
        },
        {
            id: "dateofProgramme",
            lable: "Date of Programme",
            Field_Name: "Date of Programme",
            fieldType: FormFieldTypes.DATEPICKER,
            dataField: "dateofProgramme",
            fieldSetting: {
                placeholder: "",
                options: []
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space"
            }
        },
        {
            id: "certificateofAttendance",
            lable: 'Certificate of Attendance/Completion or other proof of attendance',
            subLable: '(please upload in PDF format max 2mb)',
            Field_Name: 'file',
            fieldType: FormFieldTypes.FILE,
            dataField: 'certificateofAttendance',
            fieldSetting: {
                // presentFileName: null,
                placeholder: 'Select Profile Photo',
                isDownloadable: true,
                acceptedFiles: '.pdf',
                maxFileSizeInKB: 2048,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space"
            }
        },
        // {
        //     fieldType: FormFieldTypes.SEPARATOR,
        //     style: {
        //         containerCss: "separation-line pl-0 pr-0",
        //     },
        // },
        {
            id: "CpdPoints",
            lable: "CPD Points",
            Field_Name: "CPD Points",
            fieldType: FormFieldTypes.NUMERIC,
            dataField: "CpdPoints",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space",
            },
        },
        {
            id: "remarks",
            lable: "Remarks",
            Field_Name: "Remarks",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "remarks",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                maxLength: 4000,
            },
            // validation: [{ type: "require" }],
            style: {
                containerCss: "col-lg-12 col-12 input-margin-space",
            },
        },
        {
            fieldType: FormFieldTypes.SEPARATOR,
            style: {
                containerCss: "separation-line pl-0 pr-0",
            },
        },
        {
            id: "sgbcSection",
            lable: "",
            Field_Name: "sgbcSection",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "sgbcSection",
            fieldSetting: {
                formTitle: "SGBC Section",
            },
            style: {
                containerCss: "col-lg-12 mb-4 text-left",
            },
        },
        {
            id: "processedBy",
            lable: "Processed by",
            Field_Name: "Processed by",
            fieldType: FormFieldTypes.SELECT,
            dataField: "processedBy",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6  "
            }
        },
        {
            id: "cpdPointsAwarded",
            lable: "CPD Points Awarded",
            Field_Name: "CPD Points Awarded ",
            fieldType: FormFieldTypes.SELECT,
            dataField: "cpdPointsAwarded",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6"
            }
        },
        {
            id: "notes",
            lable: "Notes",
            Field_Name: "Notes",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "notes",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                maxLength: 4000,
            },
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 mt-3",
            },
        },
        {
            id: "rejectCPDSubmissionReason",
            lable: "Reason Of Rejection",
            Field_Name: "Reason Of Rejection",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "rejectCPDSubmissionReason",
            fieldSetting: {
                placeholder: "",
                maxLength: 400,
            },

            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 mt-3"
            }
        },
    ],
    formSetting: {
        isViewOnly: false
    }
}